import React from 'react';
import _ from 'lodash';
import selectDown from '../../assets/attend_select_down.png';
import { Button, Icon, Modal, Popover, Select, Table, Tree } from 'antd';
import { closeSockJS } from '../../utils/sockutil';
import { CHINESE, ENGLISH } from '../../utils/constants';

const Option = Select.Option;
const TreeNode = Tree.TreeNode;
const confirm = Modal.confirm;
const STATUS_NORMAL = 1;
const STATUS_APP_ERROR = 2;
const STATUS_H5_ERROR = 3;

export default class PanelMonitor extends React.Component {
  componentWillUnmount() {
    this.props.dispatch({
      type: 'monitor/setDeviceLoading',
      deviceLoading: []
    });
    closeSockJS();
  }

  render() {
    const { intl, dispatch, monitor, account } = this.props;
    const { areaData } = account;
    const { devicesData, zoneIdData, statusData } = monitor;
    let devices = this.initDevices(devicesData);
    return (
      <div className="panel-monitor monitor-container">
        <div className="monitor-left">
          <div className="monitor-area">
            <div className="monitor-area-body">
              {!_.isEmpty(areaData) && (
                <Tree
                  defaultExpandAll={true}
                  onSelect={(selectedKeys, e) => {
                    let areaObj = e.node && e.node.props.obj;
                    dispatch({
                      type: 'monitor/getRoomByArea',
                      zoneId: areaObj.id || ''
                    });
                  }}
                >
                  {this.recursionArea(areaData.child)}
                </Tree>
              )}
            </div>
          </div>
        </div>
        <div className="monitor-right">
          <div className="monitor-title">
            <div className="monitor-title-search">
              <span className="monitor-title-status">
                {intl.formatMessage({ id: 'monitor_panel_status' })}
              </span>
              <Select
                style={{ width: 110 }}
                value={String(statusData)}
                onSelect={value => {
                  dispatch({ type: 'monitor/setStatus', statusData: value });
                  dispatch({
                    type: 'monitor/getRoomByArea',
                    zoneId: zoneIdData
                  });
                }}
              >
                <Option key={'all'}>
                  {intl.formatMessage({ id: 'monitor_panel_status_all' })}
                </Option>
                <Option key={'normal'}>
                  {intl.formatMessage({ id: 'monitor_panel_status_normal' })}
                </Option>
                <Option key={'apperror'}>
                  {intl.formatMessage({ id: 'monitor_panel_status_apperror' })}
                </Option>
                <Option key={'h5error'}>
                  {intl.formatMessage({ id: 'monitor_panel_status_h5error' })}
                </Option>
              </Select>
            </div>
            <div className="monitor-title-end">
              <span className="monitor-title-result">
                {intl.formatMessage(
                  { id: 'monitor_panel_result' },
                  { value: devices.errorCount }
                )}
              </span>
              <Button
                className="monitor-title-btn"
                onClick={() => {
                  confirm({
                    title: intl.formatMessage({
                      id: 'monitor_panel_refresh_warning'
                    }),
                    okText: intl.formatMessage({ id: 'mc_btn_ok' }),
                    cancelText: intl.formatMessage({ id: 'mc_btn_cancel' }),
                    onOk() {
                      dispatch({
                        type: 'monitor/refreshAll',
                        deviceLoading: []
                      });
                    }
                  });
                }}
              >
                {intl.formatMessage({ id: 'monitor_panel_refresh_all' })}
              </Button>
            </div>
          </div>
          <div className="monitor-body">
            <div className="monitor-table">
              <Table
                columns={this.getColumns()}
                dataSource={devices.list}
                pagination={false}
                scroll={{ y: 700 }}
                locale={{
                  emptyText: intl.formatMessage({
                    id: 'smart_device_drop_down_no_data'
                  })
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  recursionArea = areaList => {
    let treeHtml = [];
    areaList &&
      areaList.map(area => {
        if (area.child && area.child.length > 0) {
          treeHtml.push(
            <TreeNode key={String(area.id)} title={area.name} obj={area}>
              {this.recursionArea(area.child)}
            </TreeNode>
          );
        } else {
          treeHtml.push(
            <TreeNode key={String(area.id)} title={area.name} obj={area} />
          );
        }
      });
    return treeHtml;
  };

  //给每行数据加上key值，并算出一共有多少个故障设备
  initDevices = devicesData => {
    let devices = { list: [], errorCount: 0 };
    if (devicesData) {
      let dataArray = [];
      let count = 0;
      devicesData.map((item, index) => {
        item['key'] = index;
        dataArray.push(item);
        if (item.deviceStatusList && item.deviceStatusList.length > 0) {
          item.deviceStatusList.map(device => {
            if (device.status !== STATUS_NORMAL) count++;
          });
        }
      });
      devices.list = dataArray;
      devices.errorCount = count;
    }
    return devices;
  };

  getColumns = () => {
    const { intl, monitor } = this.props;
    const { deviceLoading } = monitor;
    return [
      {
        title: intl.formatMessage({ id: 'monitor_panel_room_name' }),
        dataIndex: 'roomId',
        width: '25%',
        className: 'tbody-name',
        render: (text, record) => {
          return (
            <div className="tbody-row-name">
              <span>{intl.locale === ENGLISH?record.roomNameEn:record.roomName}</span>
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_position' }),
        dataIndex: 'boardDesc',
        width: '32%',
        className: 'tbody-description',
        render: (text, record) => {
          return (
            <div>
              {record.deviceStatusList &&
                record.deviceStatusList.map(device => {
                  return (
                    <div
                      key={'position' + device.uniqueId}
                      className="tbody-row tbody-row-position"
                    >
                      <span>{device.boardDesc}</span>
                    </div>
                  );
                })}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_status' }),
        dataIndex: 'status',
        width: 80,
        render: (text, record) => {
          return (
            <div>
              {record.deviceStatusList &&
                record.deviceStatusList.map(device => {
                  let status = '';
                  let color = { background: '#99ff00' };
                  switch (device.status) {
                    case STATUS_NORMAL:
                      status = intl.formatMessage({
                        id: 'monitor_panel_status_normal'
                      });
                      break;
                    case STATUS_APP_ERROR:
                      status = intl.formatMessage({
                        id: 'monitor_panel_status_apperror'
                      });
                      color = { background: '#ff6633' };
                      break;
                    case STATUS_H5_ERROR:
                      status = intl.formatMessage({
                        id: 'monitor_panel_status_h5error'
                      });
                      color = { background: '#ff6633' };
                      break;
                  }
                  let loading = false;
                  if (deviceLoading) {
                    loading = deviceLoading.some(item => {
                      return item === device.uniqueId;
                    });
                  }
                  return (
                    <div key={'status' + device.uniqueId} className="tbody-row">
                      {!loading && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div className="circle" style={color} />
                          <span>{status}</span>
                        </div>
                      )}
                      {loading && (
                        <Icon style={{ marginRight: 20 }} type={'loading'} />
                      )}
                    </div>
                  );
                })}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'monitor_panel_operation' }),
        dataIndex: 'boardType',
        width: 100,
        className: 'tbody-operation',
        render: (text, record) => {
          return (
            <div>
              {record.deviceStatusList &&
                record.deviceStatusList.map(device => {
                  let loading = false;
                  if (deviceLoading) {
                    loading = deviceLoading.some(item => {
                      return item === device.uniqueId;
                    });
                  }
                  let repairStyle = {};
                  if (device.status === STATUS_NORMAL) {
                    repairStyle.color = '#bbb';
                    repairStyle.pointerEvents = 'none';
                  }
                  return (
                    <div
                      key={'operation' + device.uniqueId}
                      className="tbody-row"
                    >
                      {!loading && (
                        <a
                          style={repairStyle}
                          onClick={() => this.repairDevice(device)}
                        >
                          {intl.formatMessage({ id: 'monitor_panel_repair' })}
                        </a>
                      )}
                      {!loading && (
                        <a onClick={() => this.deleteDevice(device)}>
                          {intl.formatMessage({ id: 'monitor_panel_delete' })}
                        </a>
                      )}
                      <Popover
                        placement="bottom"
                        trigger="hover"
                        content={
                          <div>
                            <div>
                              <a onClick={() => this.controlDevice(device, 1)}>
                                {intl.formatMessage({
                                  id: 'monitor_panel_repair_APP'
                                })}
                              </a>
                            </div>
                            <div>
                              <a onClick={() => this.controlDevice(device, 2)}>
                                {intl.formatMessage({
                                  id: 'monitor_panel_repair_H5'
                                })}
                              </a>
                            </div>
                            <div>
                              <a onClick={() => this.controlDevice(device, 3)}>
                                {intl.formatMessage({
                                  id: 'monitor_panel_repair_restart'
                                })}
                              </a>
                            </div>
                          </div>
                        }
                      >
                        <span style={{ paddingLeft: '10px' }}>
                          {intl.formatMessage({ id: 'monitor_panel_more' })}
                        </span>
                        <img src={selectDown} style={{ marginLeft: 5 }} />
                      </Popover>
                    </div>
                  );
                })}
            </div>
          );
        }
      }
    ];
  };

  repairDevice = device => {
    if (device.status === STATUS_NORMAL) return;
    this.props.dispatch({
      type: 'monitor/deviceLoading',
      uniqueId: device.uniqueId,
      value: 'add'
    });
    this.props.dispatch({
      type: 'monitor/deviceRepair',
      device: { uniqueId: device.uniqueId }
    });
  };

  controlDevice = (device, command) => {
    let commandStr = '';
    let connectStr = '';
    switch (command) {
      case 1:
        commandStr = 'restartApp';
        connectStr = 'boardApp';
        break;
      case 2:
        commandStr = 'restartH5';
        connectStr = 'boardApp';
        break;
      case 3:
        commandStr = 'adbRestartDevice';
        connectStr = 'boardApp';
        break;
    }
    this.props.dispatch({
      type: 'monitor/deviceLoading',
      uniqueId: device.uniqueId,
      value: 'add'
    });
    this.props.dispatch({
      type: 'monitor/deviceAction',
      device: {
        command: commandStr,
        connectType: connectStr,
        uniqueId: device.uniqueId
      }
    });
  };

  deleteDevice = device => {
    const { intl, dispatch } = this.props;
    confirm({
      title: intl.formatMessage({ id: 'submitDel' }),
      okText: intl.formatMessage({ id: 'mc_btn_ok' }),
      cancelText: intl.formatMessage({ id: 'mc_btn_cancel' }),
      onOk() {
        dispatch({
          type: 'monitor/unBindDevice',
          device: {
            deviceId: device.uniqueId
          }
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/monitor/PanelMonitor.js